<div class="d-flex flex-row">
  <div class="label d-flex align-items-center mr-16">
    {{ devices }}
  </div>

  @if (isBoilerUnit()) {
  <app-bu-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-bu-wiring-diagram>
  } @if (isBoilerProgrammer()) {
  <app-bp-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-bp-wiring-diagram>
  } @if (isBoilerReceiver()) {
  <app-br-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-br-wiring-diagram>
  } @if (isThermostatProgrammer()) {
  <app-pr-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-pr-wiring-diagram>
  } @if (isThermostatReceiver()) {
  <app-tr-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-tr-wiring-diagram>
  } @if (isRoomUnit()) {
  <app-ru-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-ru-wiring-diagram>
  } @if (isRoomUnitX()) {
  <app-ru-x-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-ru-x-wiring-diagram>
  } @if (isRoomUnitX2()) {
  <app-ru-x-2-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-ru-x-2-wiring-diagram>
  } @if (isLusterTerminal()) {
  <app-lt-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-lt-wiring-diagram>
  } @if (isWagoConnector()) {
  <app-tc-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-tc-wiring-diagram>
  } @if (isHeatPumpOptimizer()) {
  <app-ck-wiring-diagram
    class="diagram"
    [wiring]="wiring"
  ></app-ck-wiring-diagram>
  }
</div>
